var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4957",
    "data-name": "Group 4957",
    transform: "translate(1423 18573)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_358",
    "data-name": "Ellipse 358",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(-1423 -18573)",
    fill: "#18beb3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4956",
    "data-name": "Group 4956",
    transform: "translate(-1413 -18563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5682",
    "data-name": "Path 5682",
    d: "M12.114,12.976l.722,1.526,1.645.256a.457.457,0,0,1,.256.768L13.53,16.732l.283,1.727a.457.457,0,0,1-.676.475L11.7,18.121l-1.435.8a.457.457,0,0,1-.676-.457l.283-1.727L8.668,15.489a.457.457,0,0,1,.292-.768l1.645-.256.685-1.49a.457.457,0,0,1,.822,0Z",
    transform: "translate(-0.65 -1.01)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5683",
    "data-name": "Path 5683",
    d: "M20.191,10.311H1.914A.914.914,0,0,1,1,9.4V5.742A2.742,2.742,0,0,1,3.742,3H18.363A2.742,2.742,0,0,1,21.1,5.742V9.4A.914.914,0,0,1,20.191,10.311ZM2.828,8.483H19.277V5.742a.914.914,0,0,0-.914-.914H3.742a.914.914,0,0,0-.914.914Z",
    transform: "translate(0 -0.172)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5684",
    "data-name": "Path 5684",
    d: "M17.914,6.483A.914.914,0,0,1,17,5.569V1.914a.914.914,0,0,1,1.828,0V5.569A.914.914,0,0,1,17.914,6.483Z",
    transform: "translate(-1.379)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5685",
    "data-name": "Path 5685",
    d: "M5.914,6.483A.914.914,0,0,1,5,5.569V1.914a.914.914,0,0,1,1.828,0V5.569A.914.914,0,0,1,5.914,6.483Z",
    transform: "translate(-0.345)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5686",
    "data-name": "Path 5686",
    d: "M18.363,21.794H3.742A2.742,2.742,0,0,1,1,19.052V9.914A.914.914,0,0,1,1.914,9H20.191a.914.914,0,0,1,.914.914v9.138A2.742,2.742,0,0,1,18.363,21.794ZM2.828,10.828v8.225a.914.914,0,0,0,.914.914H18.363a.914.914,0,0,0,.914-.914V10.828Z",
    transform: "translate(0 -0.689)",
    fill: "#18beb3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimingIcon);
export default __webpack_public_path__ + "static/media/timing-icon.82c8c81da66009c5152c0ce06ddbb7a5.svg";
export { ForwardRef as ReactComponent };